import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import React from "react";

dayjs.extend(customParseFormat);

/** Display DD/MM/YYYY; store/send YYYY-MM-DD for the API. */
const DateFilterField = ({ label, value, onChange, isRTL }) => {
  const pickerValue =
    value && dayjs(value, "YYYY-MM-DD", true).isValid()
      ? dayjs(value, "YYYY-MM-DD")
      : null;

  return (
    <DatePicker
      label={label}
      format="DD/MM/YYYY"
      value={pickerValue}
      onChange={(newValue) => {
        if (newValue && newValue.isValid()) {
          onChange(newValue.format("YYYY-MM-DD"));
        } else {
          onChange("");
        }
      }}
      slotProps={{
        textField: {
          fullWidth: true,
          InputLabelProps: { shrink: true },
          inputProps: {
            dir: "ltr",
            placeholder: "dd/mm/yyyy",
          },
          sx: {
            "& .MuiInputBase-input": {
              textAlign: isRTL ? "right" : "left",
            },
          },
        },
      }}
    />
  );
};

export default DateFilterField;
